/**
 * Aba de contratos no modal de lead — relação card↔contrato é 1x1: mostra sempre o
 * formulário inline, vazio (criação) ou pré-preenchido (edição) conforme já exista ou
 * não um contrato para o cliente.
 */

import { Spin } from 'antd';
import { usePermissao } from '@/features/auth/hooks/usePermissao';
import { useClientJourney } from '@/features/vendas/hooks/useClientJourney';
import { ContratoInlineForm } from '@/features/contratos/components/form/ContratoInlineForm';
import { PipelineFormProvider } from '@/components/form/PipelineFormContext';
import { PipelineEmbeddedEmpty } from '@/components/form/pipelineFieldRow';

interface PipelineLeadContratosTabProps {
  clienteId: string;
}

export function PipelineLeadContratosTab({ clienteId }: PipelineLeadContratosTabProps) {
  const { podeCriarContrato, podeEditarContrato, podeVisualizarContratos } = usePermissao();
  const { journey, loading, refetch } = useClientJourney(clienteId);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spin />
      </div>
    );
  }

  const contratoExistente = journey?.events.find((e) => e.type === 'CONTRATO');
  const contratoId = contratoExistente ? String(contratoExistente.data.id) : undefined;
  const podeGerenciar = contratoId ? podeEditarContrato : podeCriarContrato;
  // Ex.: Secretaria — vê o contrato existente, mas não edita
  const somenteLeitura = !podeGerenciar && !!contratoId && podeVisualizarContratos;

  return (
    <PipelineFormProvider variant="pipeline">
      <div className="flex flex-col h-full px-2 py-2">
        {podeGerenciar || somenteLeitura ? (
          <ContratoInlineForm
            clienteId={clienteId}
            contratoId={contratoId}
            onSaved={() => refetch()}
            readOnly={somenteLeitura}
          />
        ) : !contratoId && podeVisualizarContratos ? (
          <PipelineEmbeddedEmpty>Nenhum contrato cadastrado para este cliente.</PipelineEmbeddedEmpty>
        ) : (
          <PipelineEmbeddedEmpty>
            Você não tem permissão para gerenciar o contrato deste cliente.
          </PipelineEmbeddedEmpty>
        )}
      </div>
    </PipelineFormProvider>
  );
}

export default PipelineLeadContratosTab;
